import { AlertTriangle } from "lucide-react";
import { ButtonLink } from "./ButtonLink";

type CalloutProps = {
  compact?: boolean;
};

export function Callout({ compact = false }: CalloutProps) {
  return (
    <aside className={`consult-callout${compact ? " consult-callout--compact" : ""}`}>
      <div className="consult-callout__copy">
        <p className="index-label consult-callout__label">
          <span className="index-label__number">15 min</span>
          <span>Video consultation</span>
        </p>
        <h2 className="display">Bring the tank. Bring the readings. Leave with a plan.</h2>
        <p>A focused 15-minute video consultation can save time and energy, reduce unnecessary purchases, and help you avoid compounding the problem.</p>
        <div className="consult-callout__actions">
          <ButtonLink href="/consultation/">Request my 15-minute consultation</ButtonLink>
          <ButtonLink href="/how-it-works/" variant="text">How it works</ButtonLink>
        </div>
      </div>
      <p className="consult-callout__safety">
        <AlertTriangle aria-hidden="true" size={16} />
        <span>Aquarium Helpline is educational support, not veterinary care. For an animal emergency, contact an aquatic veterinarian.</span>
      </p>
    </aside>
  );
}
